import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取单位列表
 */
export function getUnitList(data) {
  return fetch ({
    url: '/auth/unit/list',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 添加单位
 */
export function addUnit(data) {
  return fetch({
    url: '/auth/unit/add',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 编辑单位
 */
export function editUnit(data) {
  return fetch({
    url: '/auth/unit/edit',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除单位
 */
export function deleteUnit(data) {
  return fetch({
    url: '/auth/unit/batch/delete',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 导出单位
 */
export function exportUnit(data) {
  return formAxios({
    url: '/auth/unit/exportUnitList',
    method: 'POST',
    data
  })
}




/**
 * @param {Object} data
 * 编辑部门
 */
export function editDepartment(data) {
  return fetch({
    url: '/auth/department/save',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 删除部门
 */
export function deleteDepartment(data) {
  return fetch({
    url: '/auth/department/delete',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 根据部门id获取项目
 */
export function getProjectIdByDepartment(data) {
  return fetch({
    url: '/auth/department/getProjectIdByDepartment',
    method: 'POST',
    params
  })
}


/**
 * @param {Object} data
 * 根据unitId和部门id获取项目
 */
export function getProjectLiftTree(params) {
  return fetch({
    url: '/maintain/project/projectLiftTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getDepartmentDetail(params) {
  return fetch({
    url: '/auth/department/detail',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 获取电梯列表
 */
export function getLiftList(data) {
  return fetch ({
    url: '/maintain/lift/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取维保模板下拉框列表
 */
export function getTemplateSimpleList() {
  return fetch ({
    url: '/maintain/maintain/template/simpleList',
    method: 'GET',
  })
}


/**
 * @param {Object} data
 * 添加修改电梯信息
 */
export function saveLift(data) {
  return fetch ({
    url: '/maintain/lift/save',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除电梯信息
 */
export function deleteLift(data) {
  return fetch ({
    url: '/maintain/lift/delete',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 在保
 */
export function startMaintain(data) {
  return fetch ({
    url: '/maintain/lift/startMaintain',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 停保
 */
export function stopMaintain(data) {
  return fetch ({
    url: '/maintain/lift/stopMaintain',
    method: 'POST',
    data
  })
}


/**
 * @param {params} id
 * 获取电梯信息
 */
export function liftDetail(params) {
  return fetch ({
    url: '/maintain/lift/liftDetail',
    method: 'GET',
    params
  })
}



/**
 * @param {Object} data
 * 获取部门树形
 */
export function getDepartmentTree(data) {
  return fetch ({
    url: '/auth/subPlatform/department/getDepartmentTree',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 下载模版
 */
export function exportLiftTemplate(data) {
  return formAxios({
    url: '/maintain/lift/exportLiftTemplate',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 导出电梯
 */
export function exportLiftList(data) {
  return formAxios({
    url: '/maintain/lift/exportLiftList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 导入
 */
export function importLift(data) {
  return fetch({
    url: '/maintain/lift/importLift',
    method: 'POST',
    data
  })
}


/**
 * @param {liftId} params
 * 获取二维码
 */
export function getQrCode(params) {
  return fetch({
    url: '/maintain/lift/qrCode/v1',
    method: 'GET',
    params
  })
}


/**
 * 获取材料库
 * @param {*}
 */
export function getSimpleList(data) {
  return fetch({
    url: '/repair/materialInfo/simpleList',
    method: 'POST',
    data
  })
}


/**
 * 用户下啦接口
 * @param {*}
 */
export function getUserSimpleList(data) {
  return fetch({
    url: '/auth/subPlatform/user/simpleList',
    method: 'POST',
    data
  })
}



/**
 * 审核提交
 * @param {*}
 */
export function submitEdit(data) {
  return fetch({
    url: '/repair/manage/repair/order/submitEdit',
    method: 'POST',
    data
  })
}

/**
 * 作废费用
 * @param {*}
 */
export function removeFee(data) {
  return fetch({
    url: '/repair/manage/repair/order/removeFee',
    method: 'POST',
    data
  })
}






// WEBPACK FOOTER //
// ./src/api/ElevatorManagement/index.js